import { useLocalStore } from 'mobx-react-lite';

import { ComplaintType, ISpaceComplaint } from '@gem/models/moderationModel';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import { moderationModel } from 'APP/model/model';
import Entities from 'STORE';

import { IReportFormData } from '../../components/ReportForm/ReportForm.types';

interface IReportSpacePopupPresenter {
  hasBackButton: boolean;
  onSubmit(formData: IReportFormData): Promise<void>;
  onBack(): void;
  onClose(): void;
}

export interface IReportSpacePopupParams {
  spaceId: string;
}

export function useReportSpacePresenter({
  params,
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps<IReportSpacePopupParams>): IReportSpacePopupPresenter {
  const { spaceId } = params!;
  const { t } = useTranslation();

  const presenter = useLocalStore<IReportSpacePopupPresenter>(() => ({
    get hasBackButton(): boolean {
      return !!onBack;
    },

    async onSubmit(formData: IReportFormData): Promise<void> {
      try {
        await moderationModel.sendComplaint<ISpaceComplaint>({
          ...formData,
          complaint: {
            complaintType: ComplaintType.Space,
            spaceId,
          },
        });

        Entities.toast.show(t('content_moderation_sent_message'));
      } catch {
        Entities.toast.show(t('something_went_wrong'));
      }

      presenter.onClose();
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));

  return presenter;
}
